import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MarkdownWrapper from "@/components/markdownWrapper";
/*
  This component requires some changes to your config:
  
  ```
  // tailwind.config.js
  module.exports = {
    // ...
    plugins: [
      // ...
      require('@tailwindcss/forms'),
    ]
  }
  ```
*/

export const query = graphql`
  fragment NewsletterWithParagraphOnDarkData on StrapiComponentNewsletterWithParagraphOnDark {
    newsletter {
      topic
      title
      description
      emailPlaceholderText
      submitButtonText
      infoText
    }
  }
`;

function WithParagraphOnDark({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-dark-gray">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:flex lg:items-center lg:px-8 lg:py-16">
        <div className="lg:w-0 lg:flex-1">
          {data.newsletter.topic && (
            <h3 className="font-semibold uppercase leading-6 tracking-wide text-text-white">
              <MarkdownWrapper text={data.newsletter.topic} />
            </h3>
          )}
          {data.newsletter.title && (
            <h2
              className="text-3xl font-extrabold tracking-tight text-text-white sm:text-4xl"
              id="newsletter-headline"
            >
              <MarkdownWrapper text={data.newsletter.title} />
            </h2>
          )}
          {data.newsletter.description && (
            <MarkdownWrapper
              text={data.newsletter.description}
              markdownClassName="mt-3 max-w-3xl text-lg leading-6 text-text-secondary-light"
              replaceParagraph={false}
            />
          )}
        </div>
        <div className="mt-8 lg:ml-8 lg:mt-0">
          {data.newsletter &&
            data.newsletter.emailPlaceholderText &&
            data.newsletter.submitButtonText && (
              <form className="sm:flex">
                <label htmlFor="email-address" className="sr-only">
                  {data.newsletter.emailPlaceholderText}
                </label>
                <input
                  id="email-address"
                  name="email-address"
                  type="email"
                  autoComplete="email"
                  required
                  className="w-full rounded-md border border-transparent px-5 py-3 placeholder-placeholder-gray focus:border-border-white focus:ring-2 focus:ring-ring-white focus:ring-offset-2 focus:ring-offset-ring-offset-dark-gray sm:max-w-xs"
                  placeholder={data.newsletter.emailPlaceholderText}
                />
                <div className="mt-3 rounded-md shadow sm:ml-3 sm:mt-0 sm:flex-shrink-0">
                  <button
                    type="submit"
                    className="flex w-full items-center justify-center rounded-md border border-transparent bg-background-primary px-5 py-3 text-base font-medium text-text-white hover:bg-background-primary-dark focus:outline-none focus:ring-2 focus:ring-ring-primary focus:ring-offset-2 focus:ring-offset-ring-offset-dark-gray"
                  >
                    {data.newsletter.submitButtonText}
                  </button>
                </div>
              </form>
            )}
          {data.newsletter.infoText && (
            <MarkdownWrapper
              text={data.newsletter.infoText}
              markdownClassName="mt-3 text-sm text-text-secondary-light"
              replaceParagraph={false}
            />
          )}
        </div>
      </div>
    </div>
  );
}

WithParagraphOnDark.propTypes = {
  data: PropTypes.object,
};

export default WithParagraphOnDark;
